import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Home, Loader2, MessageCircle } from "lucide-react";
import AppLiveClock from "../components/ui/AppLiveClock";
import { selectAppUser, selectAppAuthReady, selectAppIsAuthenticated } from "../redux/appAuthSlice";
import { syncBondChatForUser } from "../redux/bondchat/generalChatSlice";
import LoungePanel from "../components/bondchat/LoungePanel";

import { HOME_PATH } from "../config/products";

const APP_HOME = HOME_PATH;

const BondChat = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectAppUser);
  const authReady = useSelector(selectAppAuthReady);
  const isAuthenticated = useSelector(selectAppIsAuthenticated);
  const { connected, activeUsersCount, unreadCount } = useSelector((s) => s.generalChat);

  useEffect(() => {
    if (user?._id) {
      dispatch(syncBondChatForUser(user._id));
    }
  }, [user?._id, dispatch]);

  useEffect(() => {
    if (authReady && !isAuthenticated) {
      navigate("/app/login", { state: { from: "/app/general-chat" } });
    }
  }, [authReady, isAuthenticated, navigate]);

  if (!authReady || !isAuthenticated) {
    return (
      <div className="bc-page-loading">
        <Loader2 size={22} className="animate-spin" />
      </div>
    );
  }

  return (
    <div className="bc-page bc-pulse-page">
      <div className="bc-pulse-bg" aria-hidden="true" />

      <header className="bc-pulse-header bc-pulse-header-compact">
        <div className="bc-pulse-header-top">
          <div className="bc-chrome-lead">
            <div className="bc-chrome-card bc-chrome-card-compact">
              <span className="bc-chrome-mark bc-chrome-mark-compact" aria-hidden>
                <MessageCircle size={13} strokeWidth={2.4} />
              </span>
              <div className="bc-chrome-copy">
                <h1 className="bc-chrome-name bc-chrome-name-compact">BondChat</h1>
                <div className="bc-chrome-meta bc-chrome-meta-compact" aria-label="Lounge summary">
                  <span className="tabular-nums">{activeUsersCount} online</span>
                  {unreadCount > 0 ? (
                    <span className="bc-chrome-meta-accent tabular-nums">
                      {unreadCount > 99 ? "99+" : unreadCount} unread
                    </span>
                  ) : null}
                  <span className={connected ? "bc-chrome-meta-live" : ""}>
                    {connected ? "Live" : "Reconnecting"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="bc-pulse-clock-wrap app-chrome-clock-center bc-pulse-clock-compact">
            <AppLiveClock className="app-chrome-clock" />
          </div>

          <div className="bc-chat-header-actions">
            <Link to={APP_HOME} className="bc-chat-home-btn bc-chat-home-btn-compact" aria-label="Back home" title="Home">
              <Home size={14} strokeWidth={2.3} aria-hidden />
            </Link>
          </div>
        </div>
      </header>

      <div className="bc-page-body">
        <section className="bc-main">
          <div className="bc-main-inner">
            <div className="bc-main-lounge">
              <LoungePanel isActive />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default BondChat;
